import React, { forwardRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import { mediaMax } from '../../../constants/breakpoints'

import { isFirefox } from '../../../utils/isBrowser'

interface SpaceProps {
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
}

export const Space = forwardRef<HTMLDivElement, SpaceProps>(({ className, style, children }, ref) => {
  const [browserSupport, setBrowserSupport] = useState(true)

  // Firefox has problems.
  useEffect(() => {
    if (isFirefox) {
      setBrowserSupport(false)
    }
  }, [])

  const final_className = `${className} ${!browserSupport ? 'browserFix' : ''}`
  return (
    <StyledSpace ref={ref} className={final_className} style={style}>
      {children}
    </StyledSpace>
  )
})
Space.displayName = 'room-space'
export default Space

const StyledSpace = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  perspective: 2000px;
  overflow: hidden;

  @media ${mediaMax.mobileL} {
    overflow: auto;
  }

  &.browserFix {
    background-color: Grey;
  }
`
